import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@surface-elements/shared/environments';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagDataService {
  private http = inject(HttpClient);
  private url = `${environment.apiUrl}/feature-flags`;

  getResolvedFlags(): Observable<Record<string, boolean>> {
    return this.http.get<Record<string, boolean>>(this.url);
  }
}
